import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {FieldShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {IdentificationServiceRequest} from 'commons/models';
import InnerFormRealOwnerIdentification from './InnerFormRealOwnerIdentification';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

RealOwnerIdentificationForm.propTypes = {
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    foreign: PropTypes.bool.isRequired,
    realOwnerIdentification: PropTypes.any,
};

const FormControl = withFormik<
    InferPropTypes<typeof RealOwnerIdentificationForm.propTypes>,
    IdentificationServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            identificationType: '',
            identificationNumber: '',
            kycId: '',
            otherIdentificationType: '',
            otherIdentificationNumber: '',
            issuingAuthority: '',
            dniFront: '',
            dniBack: '',
        };
    },
    mapPropsToValues: (props) => {
        const {realOwnerIdentification} = props;
        if (realOwnerIdentification) {
            return {
                identificationType: realOwnerIdentification.identificationType || '',
                identificationNumber: realOwnerIdentification.identificationNumber || '',
                kycId: realOwnerIdentification.kycId || 0,
                otherIdentificationType: realOwnerIdentification.otherIdentificationType || '',
                otherIdentificationNumber: realOwnerIdentification.otherIdentificationNumber || '',
                issuingAuthority: realOwnerIdentification.issuingAuthority || '',
                dniFront: realOwnerIdentification.dniFront || '',
                dniBack: realOwnerIdentification.dniBack || '',
            };
        } else {
            return {
                identificationType: '',
                identificationNumber: '',
                kycId: 0,
                otherIdentificationType: '',
                otherIdentificationNumber: '',
                issuingAuthority: '',
                dniFront: '',
                dniBack: '',
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: IdentificationServiceRequest, props) => {
        const errors: FormikErrors<IdentificationServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!props.foreign) {
            if (!values.dniFront) {
                errors.dniFront = Messages.DNI_FRONT_MISSING;
            }
            if (!values.dniBack && values.identificationType === '1') {
                errors.dniBack = Messages.DNI_BACK_MISSING;
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRealOwnerIdentification);

function RealOwnerIdentificationForm(
    props: InferPropTypes<typeof RealOwnerIdentificationForm.propTypes>
) {
    const {submitHandler, viewId, viewKey, fields, foreign, realOwnerIdentification} = props;
    return (
        <FormControl
            viewId={viewId}
            viewKey={viewKey}
            fields={fields}
            foreign={foreign}
            submitHandler={submitHandler}
            realOwnerIdentification={realOwnerIdentification}
        />
    );
}

export default RealOwnerIdentificationForm;
